import { authService } from "../../auth/auth";
import _L from "../../utils/Labels";
import { ConfirmDialog } from "../components/ConfirmDialog";
import { LOADING } from "../components/Loading";

export function _LogoutDialog() {
    new ConfirmDialog()
        .SetTitle(_L("sesion.title_confirm"))
        .SetDescription(_L("sesion.description"))
        .SetOnConfirm(async () => {
            LOADING.Show();
            await authService.logOut(true);
            LOADING.Dismiss();
        });
}